import React from 'react';
import ReactDOM from 'react-dom/client';

import './scss/app.scss';
import BookingForm from "./BookingForm";

// import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';

document.addEventListener('DOMContentLoaded', () => {
  const bookingForm = document.getElementById('lde-booking-form');
  if (bookingForm) {
    const root = ReactDOM.createRoot(bookingForm);
    root.render(
      <React.StrictMode>
        <BookingForm />
      </React.StrictMode>
    );
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
